module.exports = __webpack_public_path__ + "static/media/24UHCHR24.92f4efec.jpg";